<template>
	<div class="providerBankCard">
		<div class="title">
			<span></span>
			<span>绑定银行卡</span>
		</div>
		<div class="bank-box">
			<p>实名认证</p>
			<template v-if="!hasReal">
				<p class="tips">* 实名认证后不能修改，请如实填写</p>
			</template>
			<template v-if="hasReal">
				<div class="input-box">
					<span><p class="tips" style="display: inline;">*</p>真实姓名</span>
					{{ idCardName }}
				</div>
				<div class="input-box">
					<span><p class="tips" style="display: inline;">*</p>身份证号码</span>
					{{ idCardNumber }}
				</div>
			</template>
			<template v-else>
				<div class="input-box">
					<span><p class="tips" style="display: inline;">*</p>真实姓名</span>
					<input type="text" v-model="idCardName" placeholder="请输入真实姓名" />
				</div>
				<div class="input-box">
					<span><p class="tips" style="display: inline;">*</p>身份证号码</span>
					<input type="text" v-model="idCardNumber" placeholder="请输入身份证号码" />
				</div>
				<div class="input-box">
					<div class="idcard">
						<el-upload class="avatar-uploader" :action="uploadUrl" :show-file-list="false" :http-request="uploadFront">
						  <img v-if="imageUrlFront" :src="imageUrlFront" class="avatar">
						  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
						</el-upload>
						<p>身份证正面</p>
					</div>
					<div class="idcard">
						<el-upload class="avatar-uploader" :action="uploadUrl" :show-file-list="false" :http-request="uploadBack">
						  <img v-if="imageUrlBack" :src="imageUrlBack" class="avatar">
						  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
						</el-upload>
						<p>身份证反面</p>
					</div>
				</div>
			</template>
			<p>请绑定持卡人本人的银行卡</p>
			<div class="input-box">
				<span>卡号</span>
				<input type="text" v-model="cashAccount" placeholder="请输入银行卡号" />
			</div>
			<div class="input-box">
				<span>开户行名称</span>
				<el-select v-model="bankId" clearable placeholder="请选择开户银行" style="width: 170px;">
          <el-option v-for="(b, key) in bankList" :key="b.id" :label="b.name" :value="b.id"></el-option>
        </el-select>
			</div>
			<div class="input-box">
				<span>开户行地址</span>
				<el-select v-model="bankProvince" clearable placeholder="请选择省份" style="width: 170px;" @change="queryCitysFun">
          <el-option v-for="(item, key) in provinceList" :key="item.provinceName" :label="item.provinceName" :value="item.provinceName"></el-option>
        </el-select>
      </div>
      <div class="input-box">
				<span>&nbsp;</span>
        <el-select v-model="bankCity" clearable placeholder="请选择地市" style="width: 170px;">
          <el-option v-for="(item, key) in citysList" :key="item.citysName" :label="item.citysName" :value="item.citysName"></el-option>
        </el-select>
			</div>
			<div class="input-box">
				<input type="text" class="single" v-model="bankArea" placeholder="请填写是什么支行，如：高新支行" />
			</div>
			<template v-if="bankStatus == 0">
				<p class="text-blue" @click="deleteCard">解除绑定银行卡</p>
				<p class="tips">* 银行卡信息必须和实名信息一致，如需更改银行卡信息，请解除绑定后重新绑定。</p>
				<button class="btn-disable">确认</button>
			</template>
			<template v-else-if="bankStatus == 2">
				<p class="text-blue" @click="deleteCard">解除绑定银行卡</p>
				<p class="tips">* 银行卡信息必须和实名信息一致，如需更改银行卡信息，请解除绑定后重新绑定。</p>
				<button class="btn-disable">确认</button>
			</template>
			<template v-else>
				<button class="btn-blue" @click="bindBankCard">确认</button>
			</template>
		</div>
	</div>
</template>

<script type="text/javascript">
import axios from 'axios'
import data from './../../static/json/provinces.json'
	export default {
		name: 'providerBankCard',
		data() {
			return {
				providerCode: this.$route.query.providerCode,
				tjk_login_token: this.$route.query.token,
				phone: this.$route.query.phone,
				provinceList: [], //省份
				citysList: [], //地市
				bankList: [{
					id: 'CCB',
					name: '建设银行'
				},{
					id: 'ABC',
					name: '农业银行'
				},{
					id: 'ICBC',
					name: '工商银行'
				},{
					id: 'CMB',
					name: '招商银行'
				}],
				id: '', //绑定id
				idCardName: '', //真实姓名
				idCardNumber: '', //身份证号
				cashAccount: '', //卡号
				bankId: '', //银行卡类型
				bankProvince: '', //银行所在省份
				bankCity: '', //银行所在市
				bankArea: '', //支行名称
				bankName: '', //银行名称
				bankStatus: null, //银行卡绑定状态
				hasReal: false, //是否实名认证
				imageUrlFront: '', //身份证正面地址
				imageUrlBack: '', //身份证反面地址
				uploadUrl: API_ROOT.tjuser + '/info/uploadIdCardPicture'
			}
		},
		mounted() {
			this.provinceList = data.provinces
			if(this.tjk_login_token) {
				this.queryTjkInfo()
				this.queryBankStatus()
			}
		},
		watch: {
			bankId: function() {
				this.bankList.map((item) => {
					if(this.bankId == item.id) {
						this.bankName = item.name
					}
				})
			}
		},
		methods: {
			//查询实名认证信息
			queryTjkInfo() {
				this.$http.post(API_ROOT.tjuser + '/info/getTjkInfo', {'tjk_login_token': this.tjk_login_token}).then(response=> {
					var result = response.data
					if(result.success) {
						if(result.data.realNameAuth == 'Authenticated') {
							this.hasReal = true
							this.idCardName = result.data.realName ? result.data.realName : ''
							this.idCardNumber = result.data.idCardNumber ? result.data.idCardNumber : ''
						}else {
							this.hasReal = false
						}
					}else {
						this.$message({
							message: result.msg,
							type: 'error',
							center: true,
							duration: 3000
						})
					}
				},response=> {
					this.$message({
						message: '网络繁忙，请稍后重试！',
						type: 'error',
						center: true,
						duration: 3000
					})
				})
			},
			//查询银行卡绑定状态
			queryBankStatus() {
				this.$http.post(API_ROOT.tjuser + '/provider/getProviderCashInfo', {'tjk_login_token': this.tjk_login_token}).then(response=> {
					var result = response.data
					if(result.success) {
						if(result.data.cashInfo != null) {
							this.id = result.data.cashInfo ? result.data.cashInfo.id : ''
							this.bankStatus = result.data.cashInfo.status
							this.cashAccount = result.data.cashInfo.cashAccount
							this.bankId = result.data.cashInfo.bankId
							this.bankProvince = result.data.cashInfo.bankProvince
							this.bankCity = result.data.cashInfo.bankCity
							this.bankArea = result.data.cashInfo.bankArea
						}
					}else {
						this.$message({
							message: result.msg,
							type: 'error',
							center: true,
							duration: 3000
						})
					}
				},response=> {
					this.$message({
						message: '网络繁忙，请稍后重试！',
						type: 'error',
						center: true,
						duration: 3000
					})
				})
			},
			//根据省份查询地市
			queryCitysFun() {
				this.provinceList.map((item) => {
					if(item.provinceName == this.bankProvince) {
						this.citysList = item.citys
					}
				})
			},
			//确认绑定银行卡
			bindBankCard() {
				if(!this.hasReal) {
					if(this.idCardName == '' || this.idCardName == null) {
						this.$message({
							message: '请填写真实姓名',
							type: 'error',
							center: true,
							duration: 3000
						})
						return
					}
					if(this.idCardNumber == '' || this.idCardNumber == null) {
						this.$message({
							message: '请输入身份证号码',
							type: 'error',
							center: true,
							duration: 3000
						})
						return
					}
					if(this.imageUrlFront == '') {
						this.$message({
							message: '请上传身份证正面照片',
							type: 'error',
							center: true,
							duration: 3000
						})
						return
					}
					if(this.imageUrlBack == '') {
						this.$message({
							message: '请上传身份证反面照片',
							type: 'error',
							center: true,
							duration: 3000
						})
						return
					}
				}
				// if(this.cashAccount == '' || this.cashAccount == null) {
				// 	this.$message({
				// 		message: '请输入银行卡号',
				// 		type: 'error',
				// 		center: true,
				// 		duration: 3000
				// 	})
				// 	return
				// }
				// if(this.bankId == '' || this.bankId == null) {
				// 	this.$message({
				// 		message: '请选择开户银行',
				// 		type: 'error',
				// 		center: true,
				// 		duration: 3000
				// 	})
				// 	return
				// }
				// if(this.bankProvince == '' || this.bankProvince == null) {
				// 	this.$message({
				// 		message: '请选择省份',
				// 		type: 'error',
				// 		center: true,
				// 		duration: 3000
				// 	})
				// 	return
				// }
				// if(this.bankCity == '' || this.bankCity == null) {
				// 	this.$message({
				// 		message: '请选择地市',
				// 		type: 'error',
				// 		center: true,
				// 		duration: 3000
				// 	})
				// 	return
				// }
				// if(this.bankArea == '' || this.bankArea == null) {
				// 	this.$message({
				// 		message: '请输入支行名称',
				// 		type: 'error',
				// 		center: true,
				// 		duration: 3000
				// 	})
				// 	return
				// }				
				var data = {
					tjk_login_token: this.tjk_login_token,
					idCardName: this.idCardName,
					cashAccount: this.cashAccount,
					bankId: this.bankId,
					bankProvince: this.bankProvince,
					bankCity: this.bankCity,
					bankArea: this.bankArea,
					idCardNumber: this.idCardNumber,
					bankName: this.bankName
				}
				this.$confirm('请确认是否填写正确!银行卡信息一旦提交不允许修改！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '检查一下',
          type: 'warning'
        }).then(() => {
          this.$http.post(API_ROOT.tjuser + '/provider/providerRealNameAuthAndBindBank', data).then(response=> {
						var result = response.data
						if(result.success) {
							this.$message({
								message: '绑定成功',
								type: 'success',
								center: true,
								duration: 3000
							})
							window.location.href = '/reginalAgent/providerHasLogin?token='+this.tjk_login_token+'&phone='+this.phone+'&providerCode='+this.providerCode
						}else {
							this.$message({
								message: result.msg,
								type: 'error',
								center: true,
								duration: 3000
							})
						}
					},response=> {
						this.$message({
							message: '网络繁忙，请稍后重试！',
							type: 'error',
							center: true,
							duration: 3000
						})
					})
        }).catch(() => {
                
        })	
			},
			//解除绑定银行卡
			deleteCard() {
				var data = {
					'id': this.id,
					'cashAccount': this.cashAccount,
					'bankId': this.bankId,
					'tjk_login_token': this.tjk_login_token
				}
				this.$confirm('解除绑定会影响报酬正常发放，确认解除绑定？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http.post(API_ROOT.tjuser + '/provider/unBindBankCard', data).then(response=> {
						var result = response.data
						if(result.success) {
							this.$message({
								message: '解除绑定成功',
								type: 'success',
								center: true,
								duration: 3000
							})
							setTimeout(function() {
								window.location.reload()
							}, 1000)
						}else {
							this.$message({
								message: result.msg,
								type: 'error',
								center: true,
								duration: 3000
							})
						}
					},response=> {
						this.$message({
							message: '网络繁忙，请稍后重试！',
							type: 'error',
							center: true,
							duration: 3000
						})
					})
        }).catch(() => {
                
        })	
			},
			//上传身份证正面
	    uploadFront(item) {
	    	var self = this
		    let formData = new FormData()
		    formData.append('idCardPicture', item.file)
		    formData.append('idCardPictureType', 'IdCardPictureFront')
		    formData.append('tjk_login_token', this.tjk_login_token)
		    let config = {
          headers: {
            'Content-Type': 'multipart/form-data;',
          }
        }
        const ajax = axios.create({})
        ajax.post(API_ROOT.tjuser + "/info/uploadIdCardPicture", formData, config).then(response=> {
          var result = response.data
          if(result.success) {
          	self.imageUrlFront = URL.createObjectURL(item.file)
          }else {
            self.$alert(result.msg)
          }
        },response=> {
          self.$alert("网络繁忙，请稍后重试！")
        })
		  },
		  //上传身份证反面
	    uploadBack(item) {
	    	var self = this
		    let formData = new FormData()
		    formData.append('idCardPicture', item.file)
		    formData.append('idCardPictureType', 'IdCardPictureBack')
		    formData.append('tjk_login_token', this.tjk_login_token)
		    let config = {
          headers: {
            'Content-Type': 'multipart/form-data;',
          }
        }
        const ajax = axios.create({})
        ajax.post(API_ROOT.tjuser + "/info/uploadIdCardPicture", formData, config).then(response=> {
          var result = response.data
          if(result.success) {
          	self.imageUrlBack = URL.createObjectURL(item.file)
          }else {
            self.$alert(result.msg)
          }
        },response=> {
          self.$alert("网络繁忙，请稍后重试！")
        })
		  }
		}
	}
</script>
<style>
	.tips {
		font-size: 0.85em;
		color: red !important;
	}
	.idcard {
		float: left;
		width: 50%;
    text-align: center;
	}
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 148px;
    height: 148px;
    line-height: 148px;
    text-align: center;
  }
  .avatar {
    width: 148px;
    height: 148px;
    display: block;
  }
</style>


// WEBPACK FOOTER //
// providerBankCard.vue?0acdee45